var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.submodelElement)?_c('div',[(!!_vm.value)?_c('div',{staticClass:"grey--text text--darken-3"},[_c('truncate',[_vm._v(_vm._s(_vm.value))])],1):_c('div',{staticClass:"grey--text"},[_vm._v("<null>")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }